// components/AddMovimientoForm.jsx
import React, { useState, useEffect, useMemo } from "react";
import { postMovimiento as addMovimiento } from "../helpers/rutaMovimientos";
import { getCajas } from "../helpers/rutaCajas";
import { getGastos } from "../helpers/rutaGastos";
import { getCamiones } from "../helpers/rutaCamiones";
import { getChoferes } from "../helpers/rutaChoferes";
import { getPersonas } from "../helpers/rutaPersonas";
import { getEmpresas } from "../helpers/rutaEmpresas";
import { getClientes } from "../helpers/rutaClientes";
import { getImputas } from "../helpers/rutaImputas";
import AddGastoForm from "./AddGastoForm";

import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const MEDIOS_VALIDOS = ["EFECTIVO", "TRANSFERENCIA", "CHEQUE", "ICHEQ"];

const money = (n) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
  }).format(Number(n || 0));

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const normalizarGastos = (resp) => {
  const lista = Array.isArray(resp?.gastos)
    ? resp.gastos
    : Array.isArray(resp)
    ? resp
    : [];

  return lista.filter((g) => g.activo !== false);
};

const getCodigoGasto = (g) =>
  g?.codgas ??
  g?.codgasto ??
  g?.codgastos ??
  g?.codGasto ??
  g?.codigoGasto ??
  g?.codigo ??
  g?.nrogasto ??
  g?.numero ??
  "";

const getNombreGasto = (g) =>
  g?.gasto || g?.descripcion || g?.nombre || "Sin descripción";

const getTextoGasto = (g) => {
  const cod = getCodigoGasto(g);
  const nombre = getNombreGasto(g);
  return cod ? `${cod} - ${nombre}` : nombre;
};

const AddMovimientoForm = ({ setShow, onSaved, visible = true }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showAddGasto, setShowAddGasto] = useState(false);
  const [gastoCodigo, setGastoCodigo] = useState("");

  const [formValues, setFormValues] = useState({
    fecha: "",
    tipo: "egreso",

    // 🔥 NUEVO: desglose A/B
    montoB: "", // NEGRO
    conFactura: false,
    montoA: "", // BLANCO (TOTAL factura con IVA)
    ivaAlicuota: "21", // string para select

    descripcion: "",
    gasto: "",
    imputa: "",
    caja: "", // compat: el back lo mapea a fondo
    persona: "",
    camion: "",
    chofer: "",
    empresa: "",
    cliente: "",
    libre: "",
    medio: "",
  });

  const [cajas, setCajas] = useState({ data: [], loading: true });
  const [gastos, setGastos] = useState({ data: [], loading: true });
  const [imputas, setImputas] = useState({ data: [], loading: true });
  const [personas, setPersonas] = useState({ data: [], loading: true });
  const [camiones, setCamiones] = useState({ data: [], loading: true });
  const [choferes, setChoferes] = useState({ data: [], loading: true });
  const [empresas, setEmpresas] = useState({ data: [], loading: true });
  const [clientes, setClientes] = useState({ data: [], loading: true });

  /* ───────── carga de combos ───────── */
  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const [rc, rg, rim, rp, rcm, rch, remp, rcli] = await Promise.all([
          getCajas(),
          getGastos(),
          getImputas(),
          getPersonas(),
          getCamiones(),
          getChoferes(),
          getEmpresas(),
          getClientes(),
        ]);

        if (!mounted) return;

        const cajasList = Array.isArray(rc?.cajas) ? rc.cajas : (Array.isArray(rc) ? rc : []);
        const gastosList = normalizarGastos(rg);
        const imputasList = Array.isArray(rim?.imputas) ? rim.imputas : (Array.isArray(rim) ? rim : []);
        const personasList = Array.isArray(rp?.personas) ? rp.personas : (Array.isArray(rp) ? rp : []);
        const camionesList = Array.isArray(rcm?.camiones) ? rcm.camiones : (Array.isArray(rcm) ? rcm : []);
        const choferesList = Array.isArray(rch?.choferes) ? rch.choferes : (Array.isArray(rch) ? rch : []);
        const empresasList = Array.isArray(remp) ? remp : (Array.isArray(remp?.empresas) ? remp.empresas : []);
        const clientesList = Array.isArray(rcli?.clientes) ? rcli.clientes : (Array.isArray(rcli) ? rcli : []);

        setCajas({ data: cajasList, loading: false });
        setGastos({ data: gastosList, loading: false });
        setImputas({ data: imputasList, loading: false });
        setPersonas({ data: personasList, loading: false });
        setCamiones({ data: camionesList, loading: false });
        setChoferes({ data: choferesList, loading: false });
        setEmpresas({ data: empresasList, loading: false });
        setClientes({ data: clientesList, loading: false });
      } catch {
        if (!mounted) return;
        setCajas({ data: [], loading: false });
        setGastos({ data: [], loading: false });
        setImputas({ data: [], loading: false });
        setPersonas({ data: [], loading: false });
        setCamiones({ data: [], loading: false });
        setChoferes({ data: [], loading: false });
        setEmpresas({ data: [], loading: false });
        setClientes({ data: [], loading: false });
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);


  const recargarGastos = async () => {
    try {
      setGastos((prev) => ({ ...prev, loading: true }));
      const rg = await getGastos();
      const gastosList = normalizarGastos(rg);
      setGastos({ data: gastosList, loading: false });
    } catch (error) {
      console.error("❌ Error al recargar gastos:", error);
      setGastos((prev) => ({ ...prev, loading: false }));
    }
  };

  /* ───────── handlers ───────── */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "gasto") {
      const gastoSel = gastos.data.find((g) => String(g._id) === String(value));
      setGastoCodigo(gastoSel ? String(getCodigoGasto(gastoSel) || "") : "");
    }

    setFormValues((prev) => {
      const next = { ...prev, [name]: type === "checkbox" ? checked : value };

      // Si destildan factura: limpiamos A e IVA (y no mandamos A)
      if (name === "conFactura" && checked === false) {
        next.montoA = "";
        next.ivaAlicuota = "21";
      }

      return next;
    });
  };

  const buscarGastoPorCodigo = (codigoIngresado = gastoCodigo) => {
    const codigo = String(codigoIngresado || "").trim();

    if (!codigo) {
      setFormValues((prev) => ({ ...prev, gasto: "" }));
      return;
    }

    const gastoEncontrado = gastos.data.find(
      (g) => String(getCodigoGasto(g)).trim() === codigo
    );

    if (!gastoEncontrado) {
      alert(`No encontré un tipo de gasto con código ${codigo}`);
      setFormValues((prev) => ({ ...prev, gasto: "" }));
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      gasto: gastoEncontrado._id,
    }));

    setGastoCodigo(String(getCodigoGasto(gastoEncontrado) || ""));
  };

  const handleGastoCodigoKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      buscarGastoPorCodigo();
    }
  };

  const cerrarModalGasto = async () => {
    setShowAddGasto(false);
    await recargarGastos();
  };

  /* ───────── filtro de fondos según MEDIO (robusto) ───────── */
  const fondosFiltrados = useMemo(() => {
    const medio = (formValues.medio || "").toUpperCase().trim();

    const clasifica = (f) => {
      const tipo = (f.tipo || "").toString().toUpperCase().trim();
      const hasBankFields = Boolean(f.banco || f.alias || f.cbu || f.numero);
      const isBanco = tipo.includes("BANCO") || (!tipo.includes("CAJA") && hasBankFields);
      const isCaja = tipo.includes("CAJA") || (!isBanco && !tipo.includes("BANCO"));
      return { ...f, _isCaja: isCaja, _isBanco: isBanco };
    };

    const list = (cajas.data || []).map(clasifica);

    if (medio === "EFECTIVO") {
      const soloCajas = list.filter((f) => f._isCaja);
      return soloCajas.length ? soloCajas : list.filter((f) => !f._isBanco);
    }
    if (medio === "TRANSFERENCIA") return list.filter((f) => f._isBanco);
    return list; // CHEQUE/ICHEQ → todos
  }, [formValues.medio, cajas.data]);

  /* ───────── cálculos IVA en vivo ───────── */
  const calc = useMemo(() => {
    const b = toNum(formValues.montoB);
    const conFac = !!formValues.conFactura;

    const aTotal = conFac ? toNum(formValues.montoA) : 0;
    const alic = conFac ? toNum(formValues.ivaAlicuota) : 0;

    let neto = 0;
    let iva = 0;

    if (conFac && aTotal > 0 && alic > 0) {
      neto = aTotal / (1 + alic / 100);
      iva = aTotal - neto;
    } else if (conFac && aTotal > 0) {
      neto = aTotal;
      iva = 0;
    }

    const total = aTotal + b;

    return {
      montoA: aTotal,
      montoB: b,
      netoA: Number(neto.toFixed(2)),
      ivaA: Number(iva.toFixed(2)),
      total: Number(total.toFixed(2)),
    };
  }, [formValues.montoA, formValues.montoB, formValues.conFactura, formValues.ivaAlicuota]);

  /* ───────── submit ───────── */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const medioNormalizado = (formValues.medio || "").toString().toUpperCase().trim();
    if (!MEDIOS_VALIDOS.includes(medioNormalizado)) {
      alert("Debes seleccionar un medio válido (Efectivo, Transferencia, Cheque o iCheq).");
      return;
    }

    if ((medioNormalizado === "EFECTIVO" || medioNormalizado === "TRANSFERENCIA") && !formValues.caja) {
      alert("Debes seleccionar un Fondo (Caja/Banco) acorde al medio elegido.");
      return;
    }

    // Validación montos
    const b = calc.montoB;
    const a = calc.montoA;

    if (b < 0 || a < 0) {
      alert("Los montos no pueden ser negativos.");
      return;
    }
    if (b === 0 && a === 0) {
      alert("Debes cargar un monto (Negro y/o Blanco).");
      return;
    }
    if (formValues.conFactura && a === 0) {
      alert("Marcaste 'Con factura' pero el Monto A está en 0.");
      return;
    }




    // --- chequeos de saldo / tipo de fondo (opcionales, sin bloquear BANCO) ---
    const totalImpacto = calc.total; // A + B
    const fondoSel = (cajas.data || []).find((f) => String(f._id) === String(formValues.caja));

    if ((medioNormalizado === "EFECTIVO" || medioNormalizado === "TRANSFERENCIA") && !fondoSel) {
      alert("El fondo seleccionado no existe (recargá y probá de nuevo).");
      return;
    }

    const saldoActual = Number(fondoSel?.saldoActual || 0);
    const delta = formValues.tipo === "egreso" ? -totalImpacto : +totalImpacto;
    const saldoPost = saldoActual + delta;

    // EFECTIVO: si querés, bloqueás saldo negativo
    if (medioNormalizado === "EFECTIVO" && saldoPost < 0) {
      alert(
        `Saldo insuficiente en caja.\n` +
        `Saldo: ${money(saldoActual)}\n` +
        `Impacto: ${money(delta)}\n` +
        `Quedaría: ${money(saldoPost)}`
      );
      return;
    }

    // TRANSFERENCIA: exigir BANCO y permitir negativo (solo aviso)
    if (medioNormalizado === "TRANSFERENCIA") {
      const tipoFondo = String(fondoSel?.tipo || "").toUpperCase().trim();
      if (tipoFondo !== "BANCO") {
        alert(`Para TRANSFERENCIA tenés que elegir un fondo tipo BANCO.`);
        return;
      }

      if (saldoPost < 0) {
        const ok = window.confirm(
          `Ojo 👀: el banco quedará en negativo.\n` +
          `Saldo: ${money(saldoActual)}\n` +
          `Impacto: ${money(delta)}\n` +
          `Quedaría: ${money(saldoPost)}\n\n` +
          `¿Continuar igual?`
        );
        if (!ok) return;
      }
    }


    

    const rawPayload = {
      fecha: formValues.fecha || null,
      tipo: formValues.tipo,
      medio: medioNormalizado,

      // ✅ enviamos el desglose
      montoB: b, // siempre
      ...(formValues.conFactura
        ? {
            montoA: a, // total con IVA
            ivaAlicuota: toNum(formValues.ivaAlicuota),
            aIncluyeIVA: true, // coherente con tu idea (A es total factura)
          }
        : {}),

      descripcion: formValues.descripcion || "",
      gasto: formValues.gasto || null,
      imputa: formValues.imputa || null,
      caja: formValues.caja || null, // el back lo mapea a 'fondo'
      persona: formValues.persona || null,
      camion: formValues.camion || null,
      chofer: formValues.chofer || null,
      empresa: formValues.empresa || null,
      cliente: formValues.cliente || null,
      libre: formValues.libre || "",
    };

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    );

    try {
      const resp = await addMovimiento(payload);
      console.log("✅ Movimiento creado:", resp);

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setFormValues({
          fecha: "",
          tipo: "egreso",

          montoB: "",
          conFactura: false,
          montoA: "",
          ivaAlicuota: "21",

          descripcion: "",
          gasto: "",
          imputa: "",
          caja: "",
          persona: "",
          camion: "",
          chofer: "",
          empresa: "",
          cliente: "",
          libre: "",
          medio: "",
        });
        setGastoCodigo("");

        if (typeof onSaved === "function") onSaved();
        else if (setShow) setShow(false);
      }, 800);
    } catch (error) {
      console.error("❌ Error al crear movimiento:", error);
      alert(error?.response?.data?.message || "Error al guardar el movimiento");
    }
  };

  /* ───────── visibilidad + ready ───────── */
  const allLoaded =
    !cajas.loading &&
    !gastos.loading &&
    !imputas.loading &&
    !choferes.loading &&
    !camiones.loading &&
    !personas.loading &&
    !clientes.loading &&
    !empresas.loading;

  if (!visible) return null;

  /* ───────── render ───────── */
  return (
    <>
      {allLoaded && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            {/* FILA 1 */}
            <div className="form-row">
              <div className="form-group mt-3 col-sm-3">
                <label>Fecha</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="fecha"
                  required
                  value={formValues.fecha}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Tipo</label>
                <select
                  className="form-control"
                  name="tipo"
                  value={formValues.tipo}
                  onChange={handleChange}
                  required
                >
                  <option value="ingreso">Ingreso</option>
                  <option value="egreso">Egreso</option>
                </select>
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Medio</label>
                <select
                  className="form-control"
                  name="medio"
                  value={formValues.medio}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- seleccionar --</option>
                  <option value="EFECTIVO">EFECTIVO</option>
                  <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                  <option value="CHEQUE">CHEQUE</option>
                  <option value="ICHEQ">ICHEQ</option>
                </select>
              </div>

              <div className="form-group mt-3 col-sm-5">
                <label>Fondo</label>
                <select
                  className="form-control"
                  name="caja"
                  value={formValues.caja}
                  onChange={handleChange}
                  disabled={!formValues.medio}
                >
                  <option value="">
                    {formValues.medio ? "Elija Fondo" : "Seleccione primero un Medio"}
                  </option>
                  {fondosFiltrados.map((f) => (
                    <option key={f._id} value={f._id}>
                      {f.descripcion}{" "}
                      {f._isBanco ? `(${f.alias || f.banco || f.numero || ""})` : ""}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* FILA 2 - MONTOS */}
            <div className="form-row">
              <div className="form-group mt-3 col-sm-3">
                <label>Monto B (Negro)</label>
                <input
                  type="number"
                  className="form-control"
                  name="montoB"
                  value={formValues.montoB}
                  onChange={handleChange}
                  min="0"
                  step="0.01"
                  required={!formValues.conFactura}
                />
                <small className="form-text text-muted">{money(calc.montoB)}</small>
              </div>

              <div className="form-group mt-3 col-sm-2 d-flex align-items-end">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="conFactura"
                    name="conFactura"
                    checked={formValues.conFactura}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="conFactura">
                    Con factura (Blanco)
                  </label>
                </div>
              </div>

              <div className="form-group mt-3 col-sm-3">
                <label>Monto A (Blanco - Total)</label>
                <input
                  type="number"
                  className="form-control"
                  name="montoA"
                  value={formValues.montoA}
                  onChange={handleChange}
                  min="0"
                  step="0.01"
                  disabled={!formValues.conFactura}
                  required={formValues.conFactura}
                />
                <small className="form-text text-muted">{money(calc.montoA)}</small>
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>IVA</label>
                <select
                  className="form-control"
                  name="ivaAlicuota"
                  value={formValues.ivaAlicuota}
                  onChange={handleChange}
                  disabled={!formValues.conFactura}
                >
                  <option value="0">0%</option>
                  <option value="10.5">10.5%</option>
                  <option value="21">21%</option>
                  <option value="27">27%</option>
                </select>
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Total</label>
                <input className="form-control" value={money(calc.total)} disabled />
                {formValues.conFactura && (
                  <small className="form-text text-muted">
                    Neto: {money(calc.netoA)} · IVA: {money(calc.ivaA)}
                  </small>
                )}
              </div>
            </div>

            {/* FILA 3 */}
            <div className="form-row">
              <div className="form-group mt-3 col-sm-3">
                <label>Empresa</label>
                <select
                  className="form-control"
                  name="empresa"
                  value={formValues.empresa}
                  onChange={handleChange}
                >
                  <option value="">Elija Empresa</option>
                  {empresas.data
                    .filter((e) => e.activo !== false)
                    .map((e) => (
                      <option key={e._id} value={e._id}>
                        {e.empresa || e.razonSocial || `#${e.codemp || ""}`}
                      </option>
                    ))}
                </select>
              </div>

              <div className="form-group mt-3 col-sm-3">
                <label>Imputación</label>
                <select
                  className="form-control"
                  name="imputa"
                  value={formValues.imputa}
                  onChange={handleChange}
                >
                  <option value="">Elija Imputación</option>
                  {imputas.data.map((i) => (
                    <option key={i._id} value={i._id}>
                      {i.imputa /* ✅ sin (codimp) */}
                    </option>
                  ))}
                </select>
              </div>

            <div className="form-group mt-3 col-sm-1">
              <label>Cód. Gasto</label>
              <input
                type="number"
                className="form-control"
                value={gastoCodigo}
                onChange={(e) => setGastoCodigo(e.target.value)}
                onBlur={() => buscarGastoPorCodigo()}
                onKeyDown={handleGastoCodigoKeyDown}
                placeholder="Ej: 50"
                style={{
                  height: "24px",
                  fontSize: "12px",
                  padding: "4px 8px",
                }}
              />
            </div>

            <div className="form-group mt-3 col-sm-5">
              <label>Tipo de Gasto</label>

              <div className="d-flex align-items-center">
                <select
                  className="form-control"
                  name="gasto"
                  value={formValues.gasto}
                  onChange={handleChange}
                  style={{
                    height: "24px",
                    fontSize: "12px",
                    padding: "4px 8px",
                  }}
                >
                  <option value="">Elija gasto</option>
                  {gastos.data.map((h) => (
                    <option key={h._id} value={h._id}>
                      {getTextoGasto(h)}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  className="btn btn-success"
                  title="Agregar tipo de gasto"
                  onClick={() => setShowAddGasto(true)}
                  style={{
                    width: "32px",
                    height: "32px",
                    padding: "0",
                    marginLeft: "6px",
                    fontSize: "20px",
                    fontWeight: "bold",
                    lineHeight: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  +
                </button>
              </div>
            </div>
              {/* <div className="form-group mt-3 col-sm-3">
                <label>Tipo de Gasto</label>
                <select
                  className="form-control"
                  name="gasto"
                  value={formValues.gasto}
                  onChange={handleChange}
                >
                  <option value="">Elija gasto</option>
                  {gastos.data.map((h) => (
                    <option key={h._id} value={h._id}>
                      {getTextoGasto(h)}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mt-3 col-sm-1 d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-success btn-sm px-2"
                  title="Agregar tipo de gasto"
                  onClick={() => setShowAddGasto(true)}
                >
                  +
                </button>
              </div> */}
            </div>

            {/* FILA 4 */}
            <div className="form-row">
              <div className="form-group mt-3 col-sm-3">
                <label>Persona</label>
                <select
                  className="form-control"
                  name="persona"
                  value={formValues.persona}
                  onChange={handleChange}
                >
                  <option value="">Elija Persona</option>
                  {personas.data.map((per) => (
                    <option key={per._id} value={per._id}>
                      {per.codper ? `${per.codper} - ${per.nombre}` : per.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mt-3 col-sm-3">
                <label>Vehículo</label>
                <select
                  className="form-control"
                  name="camion"
                  value={formValues.camion}
                  onChange={handleChange}
                >
                  <option value="">Elija Camión</option>
                  {camiones.data.map((cam) => (
                    <option key={cam._id} value={cam._id}>
                      {cam.camion}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mt-3 col-sm-3">
                <label>Chofer</label>
                <select
                  className="form-control"
                  name="chofer"
                  value={formValues.chofer}
                  onChange={handleChange}
                >
                  <option value="">Elija Chofer</option>
                  {choferes.data.map((ch) => (
                    <option key={ch._id} value={ch._id}>
                      {ch.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mt-3 col-sm-3">
                <label>Cliente</label>
                <select
                  className="form-control"
                  name="cliente"
                  value={formValues.cliente}
                  onChange={handleChange}
                >
                  <option value="">Elija Cliente</option>
                  {clientes.data
                    .filter((c) => c.activo !== false)
                    .map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.razonsocial || c.nombre || `#${c.codcli || ""}`}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {/* DESCRIPCIÓN */}
            <div className="form-row">
              <div className="form-group mt-3 col-sm-12">
                <label>Descripción</label>
                <input
                  type="text"
                  className="form-control"
                  name="descripcion"
                  maxLength="100"
                  value={formValues.descripcion}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* LIBRE */}
            <div className="form-row">
              <div className="form-group mt-3 col-sm-12">
                <label>Campo Libre (opcional)</label>
                <input
                  type="text"
                  className="form-control"
                  name="libre"
                  value={formValues.libre}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div>
              <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
                Guardar
              </button>
            </div>
          </form>
        </div>
      )}

      <Modal show={showAddGasto} onHide={cerrarModalGasto} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Tipo de Gasto</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <AddGastoForm setShow={cerrarModalGasto} onSaved={cerrarModalGasto} />
        </Modal.Body>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddMovimientoForm;
